module.exports = __webpack_public_path__ + "img/user-center.8c315781.png";